import { component } from 'picoapp'

export default component((node) => {
    const button = node.querySelector('button')
    const content = node.querySelector('[data-content]')
    let isActive = false

    button?.addEventListener('click', (event) => {
        event.preventDefault()

        content.hidden = false
        isActive = true

        setTimeout(() => {
            content.classList.add('filter__content--active')
        }, 5)
    })

    document.addEventListener('click', (event) => {
        if (!isActive) {
            return
        }

        if (!node.contains(event.target)) {
            isActive = false
            content.classList.remove('filter__content--active')

            content.addEventListener(
                'transitionend',
                (event) => {
                    if (!isActive && event.target === content) {
                        content.hidden = true
                    }
                },
                { once: true }
            )
        }
    })
})
